// extracted by mini-css-extract-plugin
export default {"root":"ResultList__root--AgYqJ","loadMore":"ResultList__loadMore--xFasL"};